import { IEnumeration } from 'utility-js-enumeration';

declare var Enumeration: IEnumeration;

angular.module('data-ng-todos').constant(
  'PlacementEnum',
  Enumeration('PlacementEnum', {
    EI_PLACEMENT_TEST_WHAT_TO_EXPECT: 'EI_PLACEMENT_TEST_WHAT_TO_EXPECT',
    EI_PLACEMENT_TEST_CONTACT_US: 'EI_PLACEMENT_TEST_CONTACT_US',
    EI_PLACEMENT_TEST_APPLY_TO_ME: 'EI_PLACEMENT_TEST_APPLY_TO_ME',
    EI_PLACEMENT_TEST_SIGN_UP: 'EI_PLACEMENT_TEST_SIGN_UP',
    EI_PLACEMENT_TEST_HEADER: 'EI_PLACEMENT_TEST_HEADER'
  })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/types/placement_enum.ts